import moment from "moment";

export enum DueDateType {
	FIRST_OF_THE_MONTH = "FIRST_OF_THE_MONTH",
	LAST_OF_THE_MONTH = "LAST_OF_THE_MONTH",
	DAY_OF_THE_MONTH = "DAY_OF_THE_MONTH",
	X_AMOUNT_OF_DAYS = "X_AMOUNT_OF_DAYS",
	END_OF_NEXT_MONTH = "END_OF_NEXT_MONTH",
	X_DAYS_AFTER_END_OF_MONTH = "X_DAYS_AFTER_END_OF_MONTH",
	NEXT_WEEKDAY = "NEXT_WEEKDAY",
	SAME_DAY_NEXT_MONTH = "SAME_DAY_NEXT_MONTH",
	BUSINESS_DAYS_AFTER = "BUSINESS_DAYS_AFTER",
}

export interface IDueDate {
    due_date: moment.Moment;
    payments: IPayment[];
}

export interface IPayment {
    payment_id: number;
    payment_name: string;
    amount: number;
}

export const dueDateTypes = [
    {
        label: 'First of the month',
        key: DueDateType.FIRST_OF_THE_MONTH,
    },
    {
        label: 'Last of the month',
        key: DueDateType.LAST_OF_THE_MONTH,
    },
    {
        label: 'Specific day of the month',
        key: DueDateType.DAY_OF_THE_MONTH,
    },
    {
        label: 'X amount of days',
        key: DueDateType.X_AMOUNT_OF_DAYS,
    },
    {
        label: 'End of next month',
        key: DueDateType.END_OF_NEXT_MONTH,
    },
    {
        label: 'X days after end of month',
        key: DueDateType.X_DAYS_AFTER_END_OF_MONTH,
    },
    {
        label: 'Next weekday',
        key: DueDateType.NEXT_WEEKDAY,
    },
    {
        label: 'Same day next month',
        key: DueDateType.SAME_DAY_NEXT_MONTH,
    },
    {
        label: 'Business days after',
        key: DueDateType.BUSINESS_DAYS_AFTER,
    },
];

export const sortDueDates = (dueDates: IDueDate[]): IDueDate[] => {
    return dueDates
        .map(dueDate => ({
            ...dueDate,
            payments: [...dueDate.payments].sort((a, b) => b.amount - a.amount)
        }))
        .sort((a, b) => a.due_date.valueOf() - b.due_date.valueOf());
};
